import { Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface CashCropCellDisplayProps {
  value: any
}

export const CashCropCellDisplay = ({ value }: CashCropCellDisplayProps) => {
  const { t } = useTranslation('@cibo/landmanager/CashCropEditor')
  const { t: cropT } = useTranslation('@cibo/ui/cropNames')

  const { plantedAt, harvestedAt, preventPlant, crop } = value?.input || {}

  if (crop || preventPlant) {
    return (
      <Stack>
        {preventPlant ? (
          <>
            <Typography variant="body1">{t('preventedPlanting')}</Typography>
            <Typography variant="caption">{cropT(crop)}</Typography>
          </>
        ) : (
          <Typography variant="body1">{cropT(crop)}</Typography>
        )}
        {!!plantedAt && !!harvestedAt && (
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {t('date', { date: new Date(plantedAt) })} -{' '}
            {t('date', { date: new Date(harvestedAt) })}
          </Typography>
        )}
      </Stack>
    )
  }

  return <Typography>{cropT(value?.result)}</Typography>
}
